<template>
  <v-col class="grey lighten-4 fill-height overflow-hidden">
    <v-col class="pa-0">
      <div
        class="grey--text text--darken-2 font-weight-bold body-2 mb-1 ml-1"
      >
        Add Comment
      </div>
      <comment-textarea
        v-model="newCommentText"
        :saving="saving"
        placeholder="New comment"
        :clear-on-cancel="true"
        :focus-on-next-tick.sync="focusOnNextTick"
        @onSave="onSave"
      />
    </v-col>
    <v-col
      class="big-space-below mt-4 px-0 pt-0 fill-height overflow-y-auto"
    >
      <comment-item
        v-for="comment in sortedComments"
        :key="comment.id"
        :comment="comment"
        :current-user-is-author="authoredByCurrentUser(comment)"
      />
    </v-col>
  </v-col>
</template>

<script>
import { Reference, Researcher } from '@/models';
import moment from 'moment';
import { mapActions } from 'vuex';
import CommentItem from './CommentItem';
import CommentTextarea from './CommentTextarea';

export default {
  name: 'ReferenceCommentsPanel',
  components: { CommentItem, CommentTextarea },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      saving: false,
      editFocused: false,
      focusOnNextTick: false,
      newCommentText: '',
    };
  },
  computed: {
    currentReviewer() {
      const relevantMembers = this.reference.review.reviewMembers.filter(
        (member) => member.researcher.id === this.currentResearcher.id
      );
      return relevantMembers.length > 0
        ? relevantMembers[0]
        : undefined;
    },
    sortedComments() {
      const copy = this.reference.comments.slice(0);
      copy.sort((a, b) =>
        moment(a.createdAt).isAfter(moment(b.createdAt)) ? -1 : 1
      );
      return copy;
    },
  },
  watch: {
    reference(newRef, oldRef) {
      if (newRef?.id !== oldRef?.id) {
        this.newCommentText = '';
        this.$emit('has-unsaved-comment', false);
      }
    },
    isOpen(isOpen) {
      if (isOpen) this.onOpen();
    },
    newCommentText(commentText) {
      this.$emit('has-unsaved-comment', commentText.trim() !== '');
    },
  },
  methods: {
    ...mapActions({
      createComment: 'comment/create',
    }),
    authoredByCurrentUser(comment) {
      return this.currentReviewer.id === comment.reviewer?.id;
    },
    formattedTimestamp(dateTime) {
      return moment(dateTime).format('h:mm A Do MMM');
    },
    isEdited(comment) {
      return comment.updatedAt !== comment.createdAt;
    },
    async onSave(commentText) {
      this.saving = true;
      await this.createComment({
        referenceId: this.reference.id,
        text: commentText,
      });
      this.saving = false;
    },
    async onOpen() {
      await this.$nextTick();
      await this.$nextTick();
      this.focusOnNextTick = true;
    },
  },
};
</script>
<style scoped>
/* Without this, you can't scroll to the bottom of the comments window in all pages. */
.big-space-below {
  padding-bottom: 250px;
}
</style>
